export default "__VITE_ASSET__C0f2g1ap__"